// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-result-page {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    background-color: #191a1a;
}

.search-results-container {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: left;
    color: #fff;
    margin-left: 400px;
    margin-right: 500px;
    position: relative;

    font-family: monospace;
}


.search-results-scrollview {
    flex-grow: 1;
    overflow-y: auto; /* 允许垂直滚动 */
    padding-right: 20px; /* 为滚动条留出空间 */
}

.search-results-scrollview-bottom-bar {
    height: 300px;
}`, "",{"version":3,"sources":["webpack://./src/router/SearchResultPage.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;;IAElB,sBAAsB;AAC1B;;;AAGA;IACI,YAAY;IACZ,gBAAgB,EAAE,WAAW;IAC7B,mBAAmB,EAAE,aAAa;AACtC;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".search-result-page {\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    background-color: #191a1a;\n}\n\n.search-results-container {\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: left;\n    color: #fff;\n    margin-left: 400px;\n    margin-right: 500px;\n    position: relative;\n\n    font-family: monospace;\n}\n\n\n.search-results-scrollview {\n    flex-grow: 1;\n    overflow-y: auto; /* 允许垂直滚动 */\n    padding-right: 20px; /* 为滚动条留出空间 */\n}\n\n.search-results-scrollview-bottom-bar {\n    height: 300px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
